import Vue from 'vue'
import locale from '@lui/lui-ui/lib/locale'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import messages from './langs'

Vue.use(VueI18n)

export function getSsoLang() {
  // 默认中文
  const lang = Cookies.get('language') || 'zh_CN'
  Cookies.set('language', lang, { domain: '.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
  return lang
}

// 从localStorage中拿到用户的语言选择，如果没有，那默认中文。
const i18n = new VueI18n({
  locale: getSsoLang(),
  messages: messages as any,
  silentTranslationWarn: true
})
console.log('切换语言ele2', locale)
locale.i18n((key: string, value: any[] | { [key: string]: any } | undefined) => {
  console.log('切换语言ele')
  i18n.t(key, value)
}) // 为了实现element插件的多语言切换

export default i18n

// export function getSsoLang() {
//   // 默认中文
//   let lang = Cookies.get('language') || 'zh_CN'
//   if (Object.keys(messages).indexOf(lang) === -1) {
//     lang = 'zh_CN'
//   }
//   // lang = 'en_US'
//   Cookies.set('language', lang, { domain: '.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
//   return lang
// }
// // 从cookie中拿到用户的语言选择，如果没有，默认中文。
// const i18n = new VueI18n({
//   locale: getSsoLang(),
//   messages,
//   silentTranslationWarn: true
// })
// // 为了实现element插件的多语言切换
// locale.i18n((key: string, value: any[] | { [key: string]: any } | undefined) => {
//   i18n.t(key, value)
// })

// export default i18n
